import {
	ChangeDetectionStrategy,
	Component,
	input,
	OnChanges,
	output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormFieldLabelComponent } from '@app/shared/ui-components/form-field-label/form-field-label.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'entity-edit-title',
	imports: [
		FormFieldLabelComponent,
		MatFormFieldModule,
		NgxTolgeeModule,
		MatInputModule,
		ReactiveFormsModule,
	],
	templateUrl: './entity-edit-title.component.html',
	styleUrl: './entity-edit-title.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityEditTitleComponent implements OnChanges {
	selectedTitle = input<string>();
	titleChanged = output<string>();
	title = new FormControl('', [Validators.required]);

	ngOnChanges() {
		this.title.setValue(this.selectedTitle() || '');
	}
}
